import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VisitorCardComponent } from './visitor.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [VisitorCardComponent],
  exports: [
    VisitorCardComponent
  ],
  providers: [
  ]
})
export class VisitorCardModule { }
